import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IPContainer, IPText } from "./Components"
import { faBan, faUnlock } from '@fortawesome/free-solid-svg-icons';
import { TextButton } from "../../components/Form/Button/TextButton";
import { useTranslation } from "react-i18next";
import { IPBlockConfirm } from "./IPBlockConfirm";
import { useRef } from "react";
import SettingsService from "../../services/settings.service";
import moment from "jalali-moment";
import { useDataTable } from "../../hooks/useDataTable";
export const IP = ({row}) => {
    const {t} = useTranslation();
    const {reloadData} = useDataTable();
    const durationRef = useRef(86400)
    return (
        <IPContainer>
            <IPText $blocked={row.blocked}>{row.ip} </IPText>
            {row.blocked?(
                <TextButton 
                    name="blockIp"
                    data={row}
                    color={"success"} 
                    confirm={<IPBlockConfirm durationRef={durationRef} text={t("Are you sure to unblock the ip address?")} duration={false}/>}
                    onConfirm={() => SettingsService.unblock(row.uid, row.ip).then((d) => reloadData())}
                    updateTable={false}
                >
                    <FontAwesomeIcon icon={faUnlock} className="unblock-icon"/>
                </TextButton>
            ):(
                <TextButton 
                    name="blockIp"
                    data={row}
                    color={"danger"} 
                    confirm={<IPBlockConfirm durationRef={durationRef} text={t("Are you sure to block the ip address?")}/>}
                    onConfirm={() => SettingsService.block(row.uid, row.ip, moment().add(durationRef.current, "seconds").format("YYYY-MM-DD HH:mm:ss")).then((d) => reloadData())}
                    updateTable={false}
                >
                    <FontAwesomeIcon icon={faBan} className="block-icon"/>
                </TextButton>
            )}
        </IPContainer>
    )
}